import { Quotes } from "@phosphor-icons/react";

const testimonials = [
  {
    quote:
      "Boards, projects, and tasks finally feel like one product instead of three. New engineers find their work in minutes, not days.",
    name: "Rachel Kim",
    role: "VP of Engineering",
    company: "Digiits",
    initials: "RK",
  },
  {
    quote:
      "Atlas drafts our retro action items straight from the meeting notes. The team stopped losing follow-ups between Monday and Friday.",
    name: "David Chen",
    role: "Director of Product",
    company: "Governis",
    initials: "DC",
  },
  {
    quote:
      "Switching to Opero replaced three tools and a spreadsheet. Our project leads spend less time updating status and more time unblocking people.",
    name: "Amara Osei",
    role: "Head of Operations",
    company: "QeepTech",
    initials: "AO",
  },
];

export function TestimonialsSection() {
  return (
    <section className="relative py-24 lg:py-32">
      <div className="absolute inset-0 hex-grid-bg" />

      <div className="relative mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-2xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-500/20 dark:border-primary-500/30 bg-primary-500/5 dark:bg-primary-500/10 px-4 py-1.5 text-xs font-semibold tracking-wide text-primary-500 dark:text-primary-400 uppercase">
            <Quotes size={14} weight="fill" />
            Testimonials
          </div>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-4xl">
            Trusted by <span className="gradient-text">high-performing</span>{" "}
            teams
          </h2>
        </div>

        <div className="mt-16 grid gap-8 lg:grid-cols-3">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.name}
              className="card-snap relative rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900/50 p-8"
            >
              <Quotes
                size={32}
                weight="fill"
                className="text-primary-500/20 dark:text-primary-500/20 mb-4"
              />

              <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-400">
                &ldquo;{testimonial.quote}&rdquo;
              </p>

              <div className="mt-6 flex items-center gap-3 border-t border-slate-100 dark:border-slate-800 pt-6">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-primary-400 text-xs font-bold text-white">
                  {testimonial.initials}
                </div>
                <div>
                  <p className="text-sm font-semibold text-slate-900 dark:text-white">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-slate-500 dark:text-slate-400">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
